import { grey } from '@material-ui/core/colors';

export default () => ({
  toggleMenuItemContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  toggleMenuItemText: { flex: 1 },
  toggleMenuItem: {
    paddingRight: 0,
    display: 'flex',
  },
  toggleMenuItemSwitch: { marginLeft: '1em' },
  disabled: { color: grey[300] },
});
